import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './auth.guard';

import { SettingsComponent } from './pages/settings/settings.component';
import { TagsComponent } from './pages/tags/tags.component';
import { QueueComponent } from './pages/queue/queue.component';
import { UsersComponent } from './pages/users/users.component';
import { ArchivesComponent } from './pages/archives/archives.component';
import { ConfigurationsComponent } from './pages/configurations/configurations.component';
import { BrandingComponent } from './pages/branding/branding.component';
import { InteractionsComponent } from './pages/interactions/interactions.component';
import { ResultComponent } from './pages/result/result.component';
import { ResultCompareComponent } from './pages/result-compare/result-compare.component';

import { ModelsComponent } from './pages/models/models.component';
import { ModelsEditComponent } from './pages/models-edit/models-edit.component';
import { RetrieversFormComponent } from './pages/retrievers-form/retrievers-form.component';
import { ProcessingsFormComponent } from './pages/processings-form/processings-form.component';
import { InteractionsFormComponent } from './pages/interactions-form/interactions-form.component';
import { PreferencesComponent } from './pages/preferences/preferences.component';
import { ReferencesComponent } from './pages/references/references.component';
import { ReferenceDetailComponent } from './pages/reference-detail/reference-detail.component';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { TenantGuard } from './guards/tenant.guard';
import { BenchmarkComponent } from './pages/evaluation/evaluation.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { SimulationExecutionDetailComponent } from './pages/simulation-execution-detail/simulation-execution-detail.component';

const authenticatedChildren: Routes = [
  { path: '', redirectTo: 'simulations', pathMatch: 'full' },
  { path: 'settings', component: SettingsComponent },
  { path: 'settings/preferences', component: PreferencesComponent },
  { path: 'settings/tags', component: TagsComponent },
  { path: 'settings/users', component: UsersComponent },
  { path: 'settings/queue', component: QueueComponent },
  { path: 'settings/evaluation', component: BenchmarkComponent },
  { path: 'settings/dashboard', component: DashboardComponent },
  { path: 'settings/configurations/:type', component: ConfigurationsComponent },
  { path: 'settings/branding', component: BrandingComponent },
  { path: 'archives', component: ArchivesComponent },
  { path: 'references', component: ReferencesComponent },
  { path: 'references/:referenceId', component: ReferenceDetailComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'simulations', component: InteractionsComponent },
  { path: 'simulations/extraction/:id', component: InteractionsFormComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'simulations/classification/:id', component: InteractionsFormComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'simulations/:id', component: InteractionsFormComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'simulations/:interactionId/results/:resultId', component: ResultComponent },
  { path: 'simulations/:interactionId/compare', component: ResultCompareComponent },
  { path: 'models', component: ModelsComponent },
  { path: 'models/new', component: ModelsEditComponent },
  { path: 'models/:id', component: ModelsEditComponent },
  { path: 'retrievers/new', component: RetrieversFormComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'retrievers/:id/results/:executionId', component: SimulationExecutionDetailComponent, data: { simulationType: 'retriever' } },
  { path: 'retrievers/:id', component: RetrieversFormComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'processings/new', component: ProcessingsFormComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'processings/:id/results/:executionId', component: SimulationExecutionDetailComponent, data: { simulationType: 'processing' } },
  { path: 'processings/:id', component: ProcessingsFormComponent, canDeactivate: [CanDeactivateGuard] },
];

const routes: Routes = [
  { path: 'login', component: LoginComponent },

  {
    path: '',
    canActivate: [AuthGuard],
    children: authenticatedChildren,
  },

  {
    path: ':slug/login',
    component: LoginComponent,
    canActivate: [TenantGuard],
  },

  {
    path: ':slug',
    canActivate: [TenantGuard, AuthGuard],
    children: authenticatedChildren,
  },

  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
